import type { UseQueryResult } from '@tanstack/react-query';

import type { Group } from '../../../access/types';
import { useUserGroupsQuery } from '../../../access/hooks/use-user-groups-query';
import { useSelectedRootLocationConfiguration } from '../use-selected-root-location-configuration';

export const selectIsTemplateAdmin = (
  groups: Group[],
  templateAdminGroups: string[] | undefined
): boolean => {
  const groupsNames = groups?.map((group) => group.name);
  const cleanedGroups = templateAdminGroups?.filter(
    (value) => value.trim() !== ''
  );
  if (cleanedGroups === undefined || cleanedGroups.length === 0) {
    return true;
  }
  return cleanedGroups.some((value) => groupsNames?.includes(value));
};

export const useIsTemplateAdminQuery = (): Pick<
  UseQueryResult<boolean, Error>,
  'data' | 'isLoading'
> => {
  const selectedRootLocationConfig = useSelectedRootLocationConfiguration();
  const templateAdminGroups = selectedRootLocationConfig?.templateAdmins;

  const { data, isLoading } = useUserGroupsQuery<boolean>((groups) =>
    selectIsTemplateAdmin(groups, templateAdminGroups)
  );

  return { data, isLoading };
};
